// extracted by css-extract-rspack-plugin
export default {"infotip":"infotip--a9ATSID5VkA7eY2E"};